import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useKickAuth } from './providers/Auth/KickProvider';
import { log } from './lib/logger';

const AuthSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { checkAuthStatus: checkKickAuth } = useKickAuth();
  const [status, setStatus] = useState('Verifying authentication...');

  useEffect(() => {
    const handleAuthSuccess = async () => {
      try {
        log.debug('[AuthSuccess] OAuth callback received, updating auth state...');
        setStatus('Updating authentication status...');

        // Update the Kick login state (the only viewer login)
        await checkKickAuth();

        log.debug('[AuthSuccess] Auth state updated successfully');
        setStatus('Authentication successful! Redirecting...');

        // Get and validate redirect path
        const raw = searchParams.get('redirect') || '/';
        
        // Decode once (backend may have encoded it)
        const decoded = decodeURIComponent(raw);
        
        // Validate to avoid open redirect: only allow internal paths
        const safeRedirect = decoded && decoded.startsWith('/') ? decoded : '/';
        
        log.debug('[AuthSuccess] Redirecting to:', safeRedirect);

        // Small delay to ensure state updates propagate and user sees success message
        setTimeout(() => {
          // Use navigate for internal paths (better for SPA)
          navigate(safeRedirect, { replace: true });
        }, 500);
      } catch (error) {
        console.error('[AuthSuccess] Error during auth success handler:', error);
        setStatus('Authentication completed. Redirecting...');
        
        // Still redirect even if auth check fails
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1000);
      }
    };

    handleAuthSuccess();
  }, [navigate, searchParams, checkKickAuth]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '1rem',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        fontSize: '48px',
        animation: 'fadeIn 0.3s ease-in'
      }}>
        ✅
      </div>
      <h2 style={{ margin: 0 }}>{status}</h2>
      <div style={{
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #3498db',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.5); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default AuthSuccess;